import { AnyAction } from 'redux'

import { RootReduxState } from 'types'
import storeRegistry from 'utilities/storeRegistry'

/**
 * Store access for the auth service, which runs outside of React and so cannot
 * use hooks. Mirrors what the auth sagas did with `select`/`put`, using the
 * registered store instead. Isolated here so tests can mock store access in one
 * place.
 */
export const getReduxState = (): RootReduxState =>
    storeRegistry.getState() as RootReduxState

export const dispatch = (action: AnyAction): unknown =>
    storeRegistry.dispatch(action)
